import { j as m } from "../../jsx-runtime-ClSzPYp4.js";
import "../../Logo/CapitalOne/Loadable.mjs";
import "../../Logo/StyledPath.mjs";
import e from "../../Logo/CapitalOne/assets/CapitalOneLogoCoreDark.mjs";
import "../../Logo/PostOffice/Loadable.mjs";
import n from "../../Logo/PostOffice/assets/PostOfficeLogoCoreDark.mjs";
import "../../Logo/PostOffice/LoadableCore.mjs";
import "../../Logo/Luma/Loadable.mjs";
import L from "../../Logo/Luma/assets/LumaLogoPrimaryLight.mjs";
import f from "../../Logo/Very/assets/VeryLogoPrimary.mjs";
import l from "../../Logo/Littlewoods/assets/LittlewoodsLogoPrimary.mjs";
import "../../Logo/Littlewoods/Loadable.mjs";
import g from "../../Logo/Ocean/assets/OceanLogoPrimary.mjs";
import "../../Logo/Ocean/Loadable.mjs";
import "../../Logo/ThinkMoney/Loadable.mjs";
import O from "../../Logo/ThinkMoney/assets/ThinkMoneyLogoPrimary.mjs";
import d from "../../Logo/ASOS/assets/ASOSLogoPrimary.mjs";
import "../../Logo/ASOS/Loadable.mjs";
import "../../Logo/DirectDebit/Loadable.mjs";
import "../../Logo/BaseLogo.mjs";
import { useBrand as P } from "../../providers/BrandProvider/brandProvider.mjs";
import { C as t, a as c, c as y, V as C, P as u, O as E, d as S, L as T, T as x } from "../../brands-CoixlYYY.js";
const r = {
  [t]: (o) => /* @__PURE__ */ m.jsx(e, {
    flexShrink: 0,
    logoProps: {
      secondaryColor: [
        "capitalOne.blue750",
        null,
        "global.white"
      ]
    },
    ...o
  }),
  [x]: O,
  [T]: l,
  [S]: L,
  [E]: g,
  [u]: n,
  [C]: f,
  [y]: d
}, z = ({ allowList: o = c, brandConfig: i = r, ...a }) => {
  const p = P(o), s = i[p] || r[t];
  return /* @__PURE__ */ m.jsx(s, {
    ...a
  });
};
export {
  z as default,
  r as defaultBrandConfig
};
